export default "__VITE_ASSET__D5gcsyNO__"